<template>
  <Loader v-if="loader" />
  <div class="search-sections">
    <div class="search-section">
      <h4>Ricerca per Competenza</h4>
      <div class="header-container">
        <div class="search-container">
          <div class="date-range">
            <span>Data Emissione:</span>
            <Calendar 
              v-model="dataEmissione" 
              dateFormat="dd.mm.yy"
              :showIcon="true"
              :maxDate="maxDate"
              placeholder="Data emissione"
            />
          </div>
          <div class="date-range">
            <span>Da:</span>
            <Calendar 
              v-model="dataDa" 
              dateFormat="dd.mm.yy"
              :showIcon="true"
              :maxDate="maxDate"
              placeholder="Data da"
            />
            <span>A:</span>
            <Calendar 
              v-model="dataA" 
              dateFormat="dd.mm.yy"
              :showIcon="true"
              :maxDate="maxDate"
              placeholder="Data a"
            />
          </div>
          <Button 
            icon="pi pi-search" 
            label="Cerca" 
            @click="getDataCompetenza" 
            class="p-button-primary"
          />
        </div>
        <Button 
          icon="pi pi-file-excel" 
          label="Esporta Excel" 
          @click="exportExcelCompetenza" 
          class="p-button-success"
        />
      </div>
    </div>
  </div>

  <div class="tables-container">
    <div class="table-section" v-if="loaded_items">
      <h4>Dati Elettrico</h4>
      <DataTable 
        :value="datiElettriciFormatted"
        :paginator="true"
        :rows="10"
        v-model:expandedRows="expandedRows"
        dataKey="codiceConto"
      >
        <Column :expander="true" headerStyle="width: 3rem" />
        <Column field="codiceConto" header="Codice Conto" :sortable="true" />
        <Column field="totale_complessivo" header="Imponibile" :sortable="true">
          <template #body="{ data }">
            {{ formatCurrency(data.totale_complessivo) }}
          </template>
        </Column>
        <Column field="totale_ivato_complessivo" header="Totale" :sortable="true">
          <template #body="{ data }">
            {{ formatCurrency(data.totale_ivato_complessivo) }}
          </template>
        </Column>
        <Column field="iva_complessiva" header="IVA" :sortable="true">
          <template #body="{ data }">
            {{ formatCurrency(data.iva_complessiva) }}
          </template>
        </Column>
        <template #expansion="slotProps">
          <div class="dettaglio-mensile">
            <h5>Dettaglio Mensile</h5>
            <DataTable :value="getDettaglioMensileArray(slotProps.data.dettaglio_mensile)">
              <Column field="mese" header="Mese" />
              <Column field="totale" header="Totale">
                <template #body="{ data }">
                  {{ formatCurrency(data.totale) }}
                </template>
              </Column>
              <Column field="totale_ivato" header="Totale Ivato">
                <template #body="{ data }">
                  {{ formatCurrency(data.totale_ivato) }}
                </template>
              </Column>
              <Column field="iva" header="IVA">
                <template #body="{ data }">
                  {{ formatCurrency(data.iva) }}
                </template>
              </Column>
            </DataTable>
          </div>
        </template>
      </DataTable>
    </div>

    <div class="table-section" v-if="loaded_items">
      <h4>Dati Gas</h4>
      <DataTable 
        :value="datiGasFormatted"
        :paginator="true"
        :rows="10"
        v-model:expandedRows="expandedRowsGas"
        dataKey="codiceConto"
      >
        <Column :expander="true" headerStyle="width: 3rem" />
        <Column field="codiceConto" header="Codice Conto" :sortable="true" />
        <Column field="totale_complessivo" header="Imponibile" :sortable="true">
          <template #body="{ data }">
            {{ formatCurrency(data.totale_complessivo) }}
          </template>
        </Column>
        <Column field="totale_ivato_complessivo" header="Totale" :sortable="true">
          <template #body="{ data }">
            {{ formatCurrency(data.totale_ivato_complessivo) }}
          </template>
        </Column>
        <Column field="iva_complessiva" header="IVA" :sortable="true">
          <template #body="{ data }">
            {{ formatCurrency(data.iva_complessiva) }}
          </template>
        </Column>
        <template #expansion="slotProps">
          <div class="dettaglio-mensile">
            <h5>Dettaglio Mensile</h5>
            <DataTable :value="getDettaglioMensileArray(slotProps.data.dettaglio_mensile)">
              <Column field="mese" header="Mese" />
              <Column field="totale" header="Totale">
                <template #body="{ data }">
                  {{ formatCurrency(data.totale) }}
                </template>
              </Column>
              <Column field="totale_ivato" header="Totale Ivato">
                <template #body="{ data }">
                  {{ formatCurrency(data.totale_ivato) }}
                </template>
              </Column>
              <Column field="iva" header="IVA">
                <template #body="{ data }">
                  {{ formatCurrency(data.iva) }}
                </template>
              </Column>
            </DataTable>
          </div>
        </template>
      </DataTable>
    </div>
  </div>
</template>

<script>
import Service from "@/services/ask-pratiche/pratiche-service";
import { ref, onMounted, getCurrentInstance, computed } from "vue";
import Loader from "@/components/Loader.vue";
import Button from 'primevue/button';
import Calendar from 'primevue/calendar';
import * as XLSX from 'xlsx';

export default {
  components: {
    Loader,
    Button,
    Calendar
  },
  setup() {
    const loader = ref(false);
    const loaded_items = ref(false);
    const datiElettrici = ref({});
    const datiGas = ref({});
    const expandedRows = ref([]);
    const expandedRowsGas = ref([]);
    const dataEmissione = ref(new Date());
    const dataDa = ref(null);
    const dataA = ref(null);
    const maxDate = ref(new Date());
    
    const self = getCurrentInstance();
    self.$http = self.appContext.config.globalProperties.$http;
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    const service = new Service(self.$http, self.$eventBus);

    const datiElettriciFormatted = computed(() => {
      return Object.entries(datiElettrici.value).map(([codiceConto, dati]) => ({
        codiceConto,
        ...dati
      }));
    });

    const datiGasFormatted = computed(() => {
      return Object.entries(datiGas.value).map(([codiceConto, dati]) => ({
        codiceConto,
        ...dati
      }));
    });

    

    const getDataCompetenza = async () => {
      if (!dataEmissione.value || !dataDa.value || !dataA.value) {
        self.$eventBus.emit('showMessage', {
          severity: 'error',
          summary: 'Errore',
          detail: 'Seleziona tutte le date'
        });
        return;
      }

      loader.value = true;
      try {
        const formattedDataEmissione = new Intl.DateTimeFormat('it-IT', { 
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        }).format(dataEmissione.value).split('/').reverse().join('-');

        const formattedDateDa = new Intl.DateTimeFormat('it-IT', { 
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        }).format(dataDa.value).split('/').reverse().join('-');

        const formattedDateA = new Intl.DateTimeFormat('it-IT', { 
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        }).format(dataA.value).split('/').reverse().join('-');

        const response = await service.getInfoCodiciContoMeseCompetenza({
          data_emissione: formattedDataEmissione,
          data_a: formattedDateDa,
          data_da: formattedDateA
        });
        
        if (response && response.items) {
          const elettricoObj = {};
          const gasObj = {};

          if (Array.isArray(response.items.elettrico)) {
            response.items.elettrico.forEach((item) => {
              const codiceConto = item.codiceConto;
              const mese = item.mese;

              if (!elettricoObj[codiceConto]) {
                elettricoObj[codiceConto] = {
                  totale_complessivo: 0,
                  totale_ivato_complessivo: 0,
                  iva_complessiva: 0,
                  dettaglio_mensile: {}
                };
              }

              elettricoObj[codiceConto].totale_complessivo += parseFloat(item.totale || 0);
              elettricoObj[codiceConto].totale_ivato_complessivo += parseFloat(item.totale_ivato || 0);
              elettricoObj[codiceConto].iva_complessiva += parseFloat(item.iva || 0);

              if (mese) {
                elettricoObj[codiceConto].dettaglio_mensile[mese] = {
                  totale: parseFloat(item.totale || 0),
                  totale_ivato: parseFloat(item.totale_ivato || 0),
                  iva: parseFloat(item.iva || 0)
                };
              }
            });
          }

          if (Array.isArray(response.items.gas)) {
            response.items.gas.forEach((item) => {
              const codiceConto = item.codiceContoGAS;
              const mese = item.mese;

              if (!gasObj[codiceConto]) {
                gasObj[codiceConto] = {
                  totale_complessivo: 0,
                  totale_ivato_complessivo: 0,
                  iva_complessiva: 0,
                  dettaglio_mensile: {}
                };
              }

              gasObj[codiceConto].totale_complessivo += parseFloat(item.totale || 0);
              gasObj[codiceConto].totale_ivato_complessivo += parseFloat(item.totale_ivato || 0);
              gasObj[codiceConto].iva_complessiva += parseFloat(item.iva || 0);

              if (mese) {
                gasObj[codiceConto].dettaglio_mensile[mese] = {
                  totale: parseFloat(item.totale || 0),
                  totale_ivato: parseFloat(item.totale_ivato || 0),
                  iva: parseFloat(item.iva || 0)
                };
              }
            });
          }

          datiElettrici.value = elettricoObj;
          datiGas.value = gasObj;
          loaded_items.value = true;
        }
      } catch (error) {
        console.error("Errore nel caricamento dei dati:", error);
        self.$eventBus.emit('showMessage', {
          severity: 'error',
          summary: 'Errore',
          detail: 'Si è verificato un errore nel caricamento dei dati'
        });
      } finally {
        loader.value = false;
      }
    };

    const formatCurrency = (value) => {
      return new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR'
      }).format(value);
    };

    const getNomeMese = (numero) => {
      const mesi = [
        'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
        'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'
      ];
      return mesi[numero - 1];
    };

    const getDettaglioMensileArray = (dettaglio) => {
      return Object.entries(dettaglio).map(([mese, dati]) => ({
        mese: getNomeMese(parseInt(mese)),
        ...dati
      }));
    };

    const exportExcelCompetenza = () => {
      const wb = XLSX.utils.book_new();
      
      const formatSheet = (data, title) => {
        const headerRow = [title];
        const emptyRow = [''];
        
        const headers = [
          'Codice Conto',
          'Imponibile',
          'Totale',
          'IVA',
          ...Array.from({ length: 12 }, (_, i) => [
            `${getNomeMese(i + 1)} - Totale`,
            `${getNomeMese(i + 1)} - Totale Ivato`,
            `${getNomeMese(i + 1)} - IVA`
          ]).flat()
        ];

        const formattedData = data.map(item => {
          const row = {
            'Codice Conto': item.codiceConto,
            'Imponibile': Number(item.totale_complessivo.toFixed(2)),
            'Totale': Number(item.totale_ivato_complessivo.toFixed(2)),
            'IVA': Number(item.iva_complessiva.toFixed(2))
          };

          for (let mese = 1; mese <= 12; mese++) {
            const datiMese = item.dettaglio_mensile[mese] || { totale: 0, totale_ivato: 0, iva: 0 };
            row[`${getNomeMese(mese)} - Totale`] = Number(datiMese.totale.toFixed(2));
            row[`${getNomeMese(mese)} - Totale Ivato`] = Number(datiMese.totale_ivato.toFixed(2));
            row[`${getNomeMese(mese)} - IVA`] = Number(datiMese.iva.toFixed(2));
          }

          return row;
        });

        const ws = XLSX.utils.aoa_to_sheet([headerRow, emptyRow]);
        XLSX.utils.sheet_add_json(ws, formattedData, {
          origin: 'A3',
          skipHeader: false,
          header: headers
        });

        const range = XLSX.utils.decode_range(ws['!ref']);
        for (let R = 3; R <= range.e.r; R++) {
          for (let C = 1; C <= range.e.c; C++) {
            const cell_address = { c: C, r: R };
            const cell_ref = XLSX.utils.encode_cell(cell_address);
            if (ws[cell_ref] && typeof ws[cell_ref].v === 'number') {
              ws[cell_ref].z = '#,##0.00';
            }
          }
        }

        const cols = headers.map(() => ({ wch: 15 }));
        ws['!cols'] = cols;

        ws.A1 = { v: title, t: 's', s: { font: { bold: true, size: 14 } } };

        return ws;
      };

      const wsElettrico = formatSheet(datiElettriciFormatted.value, 'DATI ELETTRICO');
      const wsGas = formatSheet(datiGasFormatted.value, 'DATI GAS');

      XLSX.utils.book_append_sheet(wb, wsElettrico, 'Dati Elettrico');
      XLSX.utils.book_append_sheet(wb, wsGas, 'Dati Gas');

      XLSX.writeFile(wb, `Info_Codici_Conto_Competenza_${new Date().toLocaleDateString()}.xlsx`);
    };

    onMounted(() => {
    });

    return {
      loaded_items,
      loader,
      datiElettriciFormatted,
      datiGasFormatted,
      formatCurrency,
      expandedRows,
      expandedRowsGas,
      getDettaglioMensileArray,
      exportExcelCompetenza,
      dataEmissione,
      dataDa,
      dataA,
      maxDate,
      getDataCompetenza
    };
  },
};
</script>

<style scoped>
.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  gap: 1rem;
}

.search-container {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.tables-container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.table-section {
  width: 100%;
}

h4 {
  margin-bottom: 1rem;
  color: #555;
}

.dettaglio-mensile {
  padding: 1rem;
  background-color: #f8f9fa;
}

h5 {
  margin-bottom: 1rem;
  color: #666;
}

.search-sections {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-bottom: 2rem;
}

.search-section {
  background-color: #f8f9fa;
  padding: 1rem;
  border-radius: 4px;
}

.search-section h4 {
  margin-bottom: 1rem;
  color: #555;
}

.date-range {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.date-range span {
  font-size: 1.1rem;
  font-weight: 500;
  color: #495057;
  display: flex;
  align-items: center;
  height: 100%;
}
</style>

